import { useEffect, useState } from "react";
import { UrlParser } from "@authory-packages/core";

const DEFAULT_ICON = "/authory_static_files/images/web.svg";

/**
 * Builds the favicon url from the domain only, so every item of a site shares one cached icon.
 * @param src The content or source url
 * @returns The favicon url, or the default icon when no domain can be read
 */
function getFaviconURl(src: string) {
    const domain = UrlParser.extractDomain(src);
    if (!domain) return DEFAULT_ICON;

    return `https://t3.gstatic.com/faviconV2?client=SOCIAL&type=FAVICON&fallback_opts=TYPE,SIZE,URL&url=https://${domain}&size=256`;
}

export const detectFaviconImageError = (originSrc: string, skipCheck = false) => {
    const [src, setSrc] = useState(skipCheck ? DEFAULT_ICON : getFaviconURl(originSrc));

    if (typeof window === "undefined") return src;

    useEffect(() => {
        if (skipCheck) return;
        const img = new Image();

        img.onload = (e) => {
            //@ts-ignore
            if (e?.target?.height == 16) setSrc(DEFAULT_ICON);
            else setSrc(getFaviconURl(originSrc));
        }

        img.src = getFaviconURl(originSrc);

    }, [originSrc]);

    return src;
}